import './WalletCard.scss';
import { copyToClipboard, formatToDollar, formatToNaira, useOutsideClick } from '../../helpers/utils';
import Skeleton from 'react-loading-skeleton';
import { HmNuban, WalletAddress, WalletCardProps } from '../../types';
import dayjs from 'dayjs';
import { PiCaretDown } from 'react-icons/pi';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { IoCopyOutline } from 'react-icons/io5';
import { useRef, useState } from 'react';

const WalletCard = ({
  title,
  cardId,
  balance,
  isBalance = true,
  showBalance,
  image,
  active = true,
  date,
  isText,
  text,
  isAccCard,
  HMAccounts,
  cardClick = () => {},
  walletKey,
  handleDeleteClick,
  isDollar,
  canDeleteAccount = true,
  isAddressCard,
  addresses = [],
}: WalletCardProps) => {
  const [showAccDropdown, setShowAccDropdown] = useState(false);

  const dropdownRef = useRef(null);
  const actionRef = useRef(null);
  useOutsideClick(dropdownRef, setShowAccDropdown, actionRef);

  return (
    <>
      <div className={`wallet-card ${walletKey}`}>
        <div className={`card ${!active && 'not-active'}`} onClick={() => cardClick()}>
          <div className="data">
            {isAccCard && <p className="acc-title">Number of Accounts - {HMAccounts.length}</p>}
            {isAddressCard && <p className="acc-title">Number of Addresses - {addresses.length}</p>}
            <div className="image-container">{image && <img className="image" src={image} />}</div>
            <div className={`cont flex--2 ${(isAccCard || (isAddressCard && addresses.length > 0)) && 'is-acc-card'}`}>
              <div>
                <h1 className="title" title={title}>
                  {title}
                </h1>
                {isBalance && (
                  <p className="text-container">
                    {showBalance ? (
                      balance === undefined ? (
                        <Skeleton baseColor="#F6F9FB" highlightColor="#e8e8e8" width={100} />
                      ) : cardId === 'fd-card' ? (
                        formatToNaira(balance).replace('₦', '$')
                      ) : isDollar ? (
                        formatToDollar(balance)
                      ) : (
                        formatToNaira(balance)
                      )
                    ) : (
                      '. . . . '
                    )}
                  </p>
                )}

                {!isBalance && date && (
                  <p className="text-container">{dayjs(date, 'DD-MM-YYYY').format('Do MMM, YYYY')}</p>
                )}
                {isText && text && <p className="text-container">{text}</p>}
              </div>

              {(isAccCard || (isAddressCard && addresses.length > 0)) && (
                <div ref={actionRef}>
                  <PiCaretDown size={22} onClick={() => setShowAccDropdown((prev) => !prev)} />
                </div>
              )}
            </div>
          </div>
        </div>
        {isAddressCard && showAccDropdown && (
          <div className="acc-card-dropdown flex--4" ref={dropdownRef}>
            {addresses.map((item: WalletAddress) => {
              return (
                <div className="details flex--2" key={item.addressId ?? item.addressCode}>
                  <div className="">
                    <p>{item.label}</p>
                    <p className="address-code">{item.addressCode}</p>
                  </div>
                  <IoCopyOutline
                    size={20}
                    color="#4b5563"
                    className="pointer"
                    onClick={() => copyToClipboard('Address', item.addressCode)}
                  />
                </div>
              );
            })}
          </div>
        )}
        {isAccCard && showAccDropdown && (
          <div className="acc-card-dropdown flex--4" ref={dropdownRef}>
            {HMAccounts.map((item: HmNuban) => {
              return (
                <>
                  <div className="details flex--2" key={item.accountNumber}>
                    <div className="">
                      <p>{'Account Number - ' + item.bankName}</p>
                      <p>{item.accountNumber}</p>
                      {item.primaryNuban && <p>Default</p>}
                    </div>
                    {canDeleteAccount && (
                      <RiDeleteBin5Line
                        size={22}
                        color="red"
                        className="pointer"
                        key={item.accountNumber}
                        onClick={() => handleDeleteClick(item.accountNumber)}
                      />
                    )}
                  </div>
                </>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
};

export default WalletCard;
